import React from "react"
import { ModalTypes } from "../Interfaces/ContextInterfaces/GeneralContext"
import { TranslateSelecterText } from "./TranslateHelpers"
import { ParseTaggedText } from "./TagHelpers"

export function FormatSelecterModalText(text: string, codeSection: string, currentModal:
	ModalTypes['type']): JSX.Element | string {
	const translatedModal = TranslateSelecterText(currentModal)
	if (codeSection === translatedModal) {
		return <strong>{text}</strong>
	} else {
		return text
	}
}

export function FormatNoticeInfoForTagging(text: string | undefined): JSX.Element {
	if (!text) {
		return <></>
	}
	return (
		<>
			{ParseTaggedText(text).map((part, index) => (
				<span key={index} className={part.student ? "TagTextClassName" : undefined}>{part.text}</span>
			))}
		</>
	);
}